﻿import {useEffect, useState} from 'react';
import '../styles/ErrorNotifier.css';
import {useNavigate} from "react-router-dom";
import {CustomButton} from "../../Shared/components/CustomButton.jsx";

export default function ErrorNotifier({
    isOpened,
    setIsOpened,
    errorText,
    title,
    primaryButtonText,
    primaryButtonOnClick,
}) {

    const navigate = useNavigate();
    const [text, setText] = useState(errorText || 'We couldn’t update your password. Please try again or contact support if the issue continues.');

    function backgroundClick(event) {
        if (event.target === event.currentTarget) {
            setIsOpened(false)
        }
    }

    useEffect(() => {
        if (errorText) {
            setText(errorText);
        }
    }, [errorText])

    function CheckIcon(props) {
        return (
            <svg {...props} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="30" height="30" rx="15" stroke="#BA4304" strokeWidth="2"/>
                <path d="M9 8.5L23 22.5" stroke="#BA4304" strokeWidth="2" strokeLinecap="round"/>
                <path d="M23 8.5L9 22.5" stroke="#BA4304" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        );
    }

    function primaryButtonClickHandle() {
        if (primaryButtonOnClick) {
            primaryButtonOnClick();
        }
        setIsOpened(false)
    }

    return (
        isOpened && (
            <div className="modal wrapper error-notifier" onClick={backgroundClick}>
                <div className="content">
                    <div className="modal__header">
                        <div className="left-part">
                            <CheckIcon className="payment-icon"/>
                            <h1 className="payment-title">{title || "Something went wrong"}</h1>
                        </div>
                        <svg
                            className="payment-modal__close"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => setIsOpened(false)}
                        >
                            <path d="M6 6L22.9706 22.9706" stroke="#032320" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M6 23L22.9706 6.02944" stroke="#032320" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <div className="divider"></div>
                    <div className="main-text">
                        {text}
                    </div>
                    <div className="options">
                        <CustomButton
                            text={primaryButtonText || "Try Again"}
                            onClick={primaryButtonClickHandle}
                        />
                        <button className="contact-us" onClick={() => navigate("/contact-us")}>
                            Contact Support
                        </button>
                    </div>
                </div>
            </div>
        )
    );
}